module.exports = __webpack_public_path__ + "img/3.d8f43a6b.jpg";